import { createCopyPixelator } from './copy-pixelator.js';

// CSSの完了通知で内容を差し替え、連続入力は最後の選択へまとめる。
export function initCopyMosaic(copy, render, initialId, reducedMotion, pixelator = createCopyPixelator(copy)) {
  let current = initialId;
  let requested = initialId;
  let phase = null;
  let holdIn = false;
  let destroyed = false;
  let suspended = false;
  let deferred = null;

  const clear = () => {
    pixelator.stop();
    copy.classList.remove('is-mosaic-out', 'is-mosaic-in', 'is-mosaic-waiting');
  };
  const apply = () => {
    if (current === requested) return;
    current = requested;
    render(current);
  };
  const start = () => {
    if (!pixelator.capture()) { finish(); return; }
    phase = 'out';
    copy.classList.add('is-mosaic-out');
    pixelator.start();
  };
  const finish = () => {
    if (destroyed) return;
    if (deferred) requested = deferred.id;
    deferred = null;
    clear();
    phase = null;
    holdIn = false;
    apply();
  };
  const show = (id) => {
    if (destroyed) return;
    if (suspended) { deferred = { id, run: () => show(id) }; return; }
    if (requested === id) return;
    requested = id;
    if (reducedMotion.matches) finish();
    else if (!phase && current !== requested) start();
  };
  const onEnd = (event) => {
    if (event.target !== copy || suspended) return;
    if (phase === 'out' && event.animationName === 'copy_mosaic_out') {
      clear();
      apply();
      if (holdIn) {
        phase = 'waiting';
        copy.classList.add('is-mosaic-waiting');
        return;
      }
      if (!pixelator.capture()) { finish(); return; }
      phase = 'in';
      copy.classList.add('is-mosaic-in');
      pixelator.start();
    } else if (phase === 'in' && event.animationName === 'copy_mosaic_in') {
      clear();
      phase = null;
      if (current !== requested) start();
    }
  };
  const onMotion = () => { if (reducedMotion.matches) finish(); };
  copy.addEventListener('animationend', onEnd);
  reducedMotion.addEventListener('change', onMotion);

  const controller = {
    show,
    prepare(id) {
      if (destroyed) return;
      if (suspended) { deferred = { id, run: () => controller.prepare(id) }; return; }
      requested = id;
      holdIn = true;
      if (reducedMotion.matches) finish();
      else if (!phase || phase === 'in') {
        clear();
        phase = null;
        start();
      }
    },
    reveal(id) {
      if (destroyed) return;
      if (suspended) { deferred = { id, run: () => controller.reveal(id) }; return; }
      clear();
      phase = null;
      holdIn = false;
      requested = id;
      apply();
      if (reducedMotion.matches || !pixelator.capture()) return;
      phase = 'in';
      copy.classList.add('is-mosaic-in');
      pixelator.start();
    },
    finish,
    setSuspended(value) {
      if (destroyed || suspended === value) return;
      if (value) {
        // 進行中のモザイクを読める内容へ確定し、休止中の選択は最後だけ保持する。
        finish();
        suspended = true;
      } else {
        suspended = false;
        const next = deferred;
        deferred = null;
        next?.run();
      }
    },
    destroy() {
      destroyed = true;
      deferred = null;
      copy.removeEventListener('animationend', onEnd);
      reducedMotion.removeEventListener('change', onMotion);
      clear();
      pixelator.destroy();
      phase = null;
    },
  };
  return controller;
}
